import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    { 
      path: '/', 
      redirect: '/login',
    },
    { path: '/login', name: 'Login', component: resolve => require(['@/pages/Login/Login'],resolve) },
    { path: '/homepage', name: 'Homepage', component: resolve => require(['@/pages/Homepage/Homepage'],resolve) },
    { path: '/about', name: 'About', component: resolve => require(['@/pages/Term/About'],resolve) },
    { path: '/pravicy', name: 'Pravicy', component: resolve => require(['@/pages/Term/Pravicy'],resolve) },
    { path: '/waiting', name: 'Waiting', component: resolve => require(['@/pages/Zplus/Waiting'],resolve) },
    { path: '*', name: 'URLerror', component: resolve => require(['@/pages/Zplus/URLerror'],resolve) }, //按顺序匹配，需在最后。触发未匹配任何路径的error界面。
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js